// Verbatim port of legacy
// frontend/src/pages/Category/PantryCategory/validation.ts. Yup schema for
// the create / edit form, plus the `toSlug` helper used to derive a slug
// from a display name (mirrored in categoryApis.ts:85-91 for backend use).

import * as Yup from 'yup'
import type { PantryCategoryFormValues } from './types'

const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

export const pantryCategorySchema: Yup.ObjectSchema<PantryCategoryFormValues> =
  Yup.object({
    displayName: Yup.string().trim().required('Display name is required'),
    slug: Yup.string()
      .trim()
      .required('Slug is required')
      .matches(
        SLUG_REGEX,
        'Slug must use lowercase letters, numbers, and hyphens only',
      ),
    visible: Yup.boolean().required(),
    // Mirrors Brand: when true, the slug input is locked and Display Name
    // changes don't auto-derive it. Always defined on the form, so `.required()`.
    slugLocked: Yup.boolean().required(),
    headline: Yup.string().trim().max(255, 'Headline is too long'),
    description: Yup.string().trim().max(5000, 'Description is too long'),
    seoTitle: Yup.string()
      .trim()
      .max(60, 'SEO title must be 60 characters or less'),
    seoDescription: Yup.string()
      .trim()
      .max(160, 'Meta description must be 160 characters or less'),
    parentId: Yup.mixed<string | number>().notRequired(),
  })

export const toSlug = (value: string) =>
  value
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
